// project imports
import { EMSMemberAccountStatus } from 'utils/constants';

// types
import { i18nEaiSubjects } from 'models/i18n';

// ==============================|| I18N EN SUBJECTS ||============================== //

const enEaiSubjects: i18nEaiSubjects = {
  createSubjectWizard: {
    title: 'Create subject',
    step01: 'Subject data',
    step02: 'Subject role',
    step03: 'Service level',
    step04: 'Market participant data',
    save: 'Create subject'
  },
  subjectDetail: {
    userData: {
      title: 'User info',
      basicInfo: 'Basic info',
      deleteSubject: 'Delete subject'
    },
    userAccount: {
      title: 'User accounts',
      account: 'Account',
      accountState: {
        [EMSMemberAccountStatus.ACTIVE]: 'Invalidate account',
        [EMSMemberAccountStatus.INACTIVE]: 'Recover account'
      },
      serviceLevelCodeHistory: 'Service level history',
      serviceLevelSpecificationId: 'Service level'
    },
    marketParticipantData: {
      title: 'Market participant data',
      marketParticipantCredentials: 'External services credentials',
      basicInfo: 'Basic info',
      type: 'Service type',
      username: 'Username',
      actions: 'Actions',
      addCredentials: 'Add credentials'
    },
    createSubjectAccountWizard: {
      title: 'Create subject account',
      step01: 'Subject account role',
      step02: 'Service level',
      step03: 'Market participant data',
      save: 'Create subject account'
    }
  },
  subjectList: {
    title: 'Subject List',
    searchInput: 'Enter name/EIC/ID',
    createEntityButton: 'Create subject',
    columns: {
      name: 'Name',
      partyIdentifier: 'Identification number',
      eic: 'EIC',
      serviceLevel: 'Service level',
      status: 'Account state',
      validTo: 'Valid to'
    },
    filter: {
      status: 'Account status',
      levelCode: 'Service level',
      validity: 'Validity'
    }
  },
  input: {
    EMSPartyName: 'Name',
    EMSPartyType: 'Subject type',
    EMSPartyIdentifier: 'Identification number',
    EMSMemberAccountType: 'Subject role',
    ServiceLevelCode: 'Service level',
    EnergyMarketParticipantRole: 'Market participant role',
    ImbalanceResponsibilityMode: 'Imbalance responsibility',
    EMSMemberAccountName: 'Name',
    EMSMemberAccountEic: 'EIC',
    username: 'Username',
    password: 'Password',
    clientCertificateFile: 'Drag and drop a certificate or',
    uploadClientCertificateFile: 'click to upload',
    certificateMaxSize: 'Maximum file size 500 kB',
    fileSize: 'File size: ',
    fileSizeBytes: ' B',
    MarketParticipantCredentialsType: 'External service'
  },
  validation: {
    'EMSPartyName-required': 'Subject name is mandatory',
    'EMSPartyName-max': 'Maximum length exceeded',
    'EMSPartyName-mail': 'Incorrect format of subject name',
    'EMSPartyName-exists': 'Subject name must be unique',
    'EMSPartyType-required': 'Subject type is mandatory',
    'EMSPartyIdentifier-required': 'Identification number is mandatory',
    'EMSPartyIdentifier-matches': 'Identifier must be max 16 alfanumeric chars',
    'EMSPartyIdentifier-exists': 'Identifier must be unique',
    'EMSMemberAccountName-required': 'Meno/názov účtu subjektu je povinné',
    'EMSMemberAccountType-required': 'Subject role is mandatory',
    'ServiceLevelCode-required': 'Service level is mandatory',
    'EnergyMarketParticipantRole-required':
      'Market participant role is mandatory',
    'ImbalanceResponsibilityMode-required':
      'Imbalance responsibility is mandatory',
    'EMSMemberAccountEic-required': 'EIC is mandatory',
    'EMSMemberAccountEic-max': 'Length must be 16 characters',
    'EMSMemberAccountEic-exists': 'EIC must be unique',
    'username-required': 'Username is mandatory',
    'password-required': 'Password is mandatory',
    'clientCertificateFile-required': 'Password is mandatory',
    'MarketParticipantCredentialsType-required': 'External service is mandatory'
  }
};

export default enEaiSubjects;
